import { mapperGlobalDataTheme } from '../../global-data/mappers'
import { mapperModuleNavigationLink } from '../../modules/mappers'
import type { MapperOptions } from '~/types'

export const mapperBlockIndexHighlight = (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    title: data.title || '',
    text: data.text,
    isFullScreen: data.isFullScreen || false,
    link: mapperModuleNavigationLink(data.link, options.getUrl),
    theme: mapperGlobalDataTheme(data.sectionTheme)?.theme || null
  }
}
